import * as React from "react";

export const useChoiceByDate = (
  auditDate: Date | undefined,
  choiceLength: number,
): number => {
  const [choice, setChoice] = React.useState<number>(-1);

  React.useEffect(() => {
    if (auditDate) {
      setChoice(auditDate.getMonth() % choiceLength);
    } else {
      setChoice(-1);
    }
  }, [auditDate, choiceLength]);

  return choice;
};
